import { APIService } from '../api';
import { Model } from './Model';
import { HasOne, Relations } from './Relations';
import { User } from './User';

export class ChatMessageStatus extends Model implements Relations<ChatMessageStatus> {
    public static SENT = 1 << 0;
    public static RECEIVED = 1 << 1;
    public static READ = 1 << 2;

    public readonly blueprint = ChatMessageStatus;
    public readonly endpoint = APIService.createLambdaEndpoint(
        'chat/rooms/{room_id}/messages/{message_id}/statuses/{status_id}',
    );

    public relations() {
        return [HasOne('user', User, ChatMessageStatus)];
    }

    public user_id!: number;
    public user!: User;

    public status!: number;

    public addStatusFlag(status: number): ChatMessageStatus {
        this.status |= status;

        return this;
    }

    public toggleStatusFlag(status: number): ChatMessageStatus {
        this.status ^= status;

        return this;
    }

    public clearStatusFlag(): ChatMessageStatus {
        this.status = ChatMessageStatus.SENT;

        return this;
    }

    public isSent(): boolean {
        return this.hasStatusFlag(ChatMessageStatus.SENT);
    }

    public hasStatusFlag(status: number): boolean {
        return (this.status & status) !== 0;
    }

    public isReceived(): boolean {
        return this.hasStatusFlag(ChatMessageStatus.RECEIVED);
    }

    public isRead(): boolean {
        return this.hasStatusFlag(ChatMessageStatus.READ);
    }
}
